import { combineReducers } from "redux";
import { pageReducer } from "../components/Page/redux/PageReducer";
import { featureManagementReducer } from "../FeatureManagement/redux/FeatureManagementReducer";
import { testReducer } from "../../views/TestView/redux/TestReducer";

export default combineReducers({
    pageViewState: pageReducer, 
    testViewState: testReducer,
    featureManagementViewState: featureManagementReducer,
});